export const AVAILABLE_SERVICE_PROVIDERS = {}
